import { useSelector } from "react-redux";
import {
    selectHasKissSign,
    selectLoggedInArtist,
    selectLoggedInArtistID, selectLoggedInCannotEdit,
    selectLoggedInIsAdmin
} from "../store/auth/authSelector";
import {
    selectArtistMap,
    selectIsCommonStateLoading,
    selectStudioDescriptionLanguage,
    selectStudioGutscheinverkauf,
    selectStudioTatOrtID,
    selectStudioTatortMap,
    selectStudioTimezone,
    selectStudioWaehrung,
    selectTermintypMap
} from "../store/common/commonSelector";
import { useLoggedInArtistLocale } from "./useLoggedInArtistLocale";
import { useLoggedInArtistRights } from "./useLoggedInArtistRights";


const useCommonState = () => {
    const timezone = useSelector(state => selectStudioTimezone(state))
    const gutscheinverkauf = useSelector(state => selectStudioGutscheinverkauf(state))
    const isStateLoaded = !useSelector(state => selectIsCommonStateLoading(state))
    const studioDescriptionLanguage = useSelector(state => selectStudioDescriptionLanguage(state))
    const termintypMap = useSelector(state => selectTermintypMap(state))
    const locale = useLoggedInArtistLocale()
    const hasKissSign = useSelector(state => selectHasKissSign(state))
    const waehrung = useSelector(state => selectStudioWaehrung(state))
    const artistMap = useSelector(state => selectArtistMap(state))
    const tatortMap = useSelector(state => selectStudioTatortMap(state))
    const studioTatOrtID = useSelector(state => selectStudioTatOrtID(state))
    const { writableArtistIdList: artistIdListWrite, rightsMap: loggedInRechte } = useLoggedInArtistRights()

    const isAdmin = useSelector(state => selectLoggedInIsAdmin(state))
    const cannotEdit = useSelector(state => selectLoggedInCannotEdit(state))
    const loggedInArtistId = useSelector(state => selectLoggedInArtistID(state))
    const loggedInArtist = useSelector(state => selectLoggedInArtist(state))

    return {timezone, gutscheinverkauf, isStateLoaded, locale, waehrung, hasKissSign, artistMap, tatortMap,
        studioTatOrtID, isAdmin, loggedInRechte, loggedInArtistId, loggedInArtist, cannotEdit,
        termintypMap, artistIdListWrite, studioDescriptionLanguage}
}

export default useCommonState